module.exports = __webpack_public_path__ + "img/储能升压⼀体机.ef24ea1d.png";